/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default async () => {
  const [LoyaltySaga] = await Promise.all([
    import(/* webpackChunkName: "loyalty-view" */ './Loyalty.saga'),
  ]);
  useInjectReducerAndSaga(null, { key: 'Loyalty', saga: LoyaltySaga.default });
  return null;
};
